import React from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import NumericFormat from "../../../components/react-number-format/NumericFormat";
var tKey = "wrappers.NotificationToastsDecorator.impl.BoostCreatedNotificationToast";
function BoostCreatedNotificationToast(props) {
  var notificationId = props.notificationId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var notification = useSelector(function (state) {
    return state.entities.notifications.byId[notificationId];
  });
  var boostId = notification.event.objects[0].objectId;
  var boost = useSelector(function (state) {
    return state.entities.boosts.byId[boostId];
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, t("".concat(tKey, ".header"))), "\xA0\xB7\xA0", moment(notification.createdAt).fromNow(true)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".body"),
    components: {
      small: /*#__PURE__*/React.createElement("small", null),
      boostAmount: /*#__PURE__*/React.createElement(NumericFormat, {
        displayType: "text",
        decimalScale: boost.currency.unitDecimalScale,
        value: boost.amount,
        className: "me-1"
      }),
      lnk: /*#__PURE__*/React.createElement(Link, {
        to: "/boosts/non-finalized"
      }),
      lnk2: /*#__PURE__*/React.createElement(Link, {
        to: "/investment-items"
      })
    },
    values: {
      unitAbbreviation: boost.currency.unitAbbreviation,
      boostDuration: boost.durationInDays
    }
  })));
}
export default BoostCreatedNotificationToast;
BoostCreatedNotificationToast.propTypes = {
  notificationId: PropTypes.number.isRequired
};